import { render, staticRenderFns } from "./kefu.vue?vue&type=template&id=06d7aed2&scoped=true&"
import script from "./kefu.vue?vue&type=script&lang=js&"
export * from "./kefu.vue?vue&type=script&lang=js&"
import style0 from "./kefu.vue?vue&type=style&index=0&id=06d7aed2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d7aed2",
  null
  
)

export default component.exports